var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { align: "center", justify: "center" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12", sm: "8", md: "5", lg: "4", xl: "3" } },
        [
          _c(
            "v-card",
            {
              staticClass: "elevation-12",
              attrs: { loading: _vm.$async.authenticate.$pending },
            },
            [
              _c(
                "v-toolbar",
                { attrs: { elevation: "1" } },
                [
                  _c("v-toolbar-title", [
                    _c("span", { staticClass: "title ml-3 mr-1" }, [
                      _vm._v(_vm._s(_vm.$t("page-sign-in.title"))),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c("div", { staticStyle: { "min-height": "48px" } }, [
                    _vm.invalidCredentials
                      ? _c(
                          "div",
                          { staticClass: "red--text" },
                          [
                            _c("v-icon", { attrs: { color: "red" } }, [
                              _vm._v("mdi-alert"),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("page-sign-in.wrongCredentials")
                                ) +
                                " "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _c("FormSignIn", {
                    attrs: { loading: _vm.$async.authenticate.$pending },
                    on: { submit: _vm.onSubmit },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }